export default __webpack_public_path__ + "static/media/(6).e5b23d3b.jpg";